import { FileOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import { documentsApi } from 'api/documents';
import { getMIMEByExtension } from 'pages/ApplicationDetailsPage/helpers';
import type { IDocumentFormatted } from 'queries/applications/useApplicationByReferenceNumber/types';
import { DocumentTypeEnum } from '../../../legacy/shared-types';
import { formatDateTimeLondonNoTz } from 'utils/dates';

export interface ICustomerFilesListItemProps {
  document: IDocumentFormatted;
}

const DOCUMENT_TYPE_LABEL: Record<DocumentTypeEnum, string> = {
  [DocumentTypeEnum.BANK_STATEMENT]: 'Bank statement',
  [DocumentTypeEnum.PROOF_OF_INCOME]: 'Proof of income',
  [DocumentTypeEnum.PROOF_OF_DEPOSIT]: 'Proof of deposit',
  [DocumentTypeEnum.OTHER]: 'Other',
};

function getDocumentTypeLabel(type: DocumentTypeEnum): string {
  return DOCUMENT_TYPE_LABEL[type] ?? type;
}

export const CustomerFilesListItem = ({ document }: ICustomerFilesListItemProps) => {
  const handleViewClick = () => {
    const fileType = getMIMEByExtension(document.originalFileName);
    documentsApi.getFileById(document.id).then(res => {
      const url = window.URL.createObjectURL(new Blob([res], { type: fileType }));
      window.open(url, '_blank');
    });
  };

  return (
    <Flex align='center' justify='space-between' className='bg-slate-50 p-4 rounded-lg'>
      <Flex align='center' className='gap-3'>
        <div className='flex h-8 w-8 shrink-0 items-center justify-center p-2'>
          <FileOutlined className='h-[18px] w-[18px] shrink-0' />
        </div>
        <Flex vertical className='gap-1'>
          <Typography.Text className='text-sm font-semibold leading-5 text-black'>
            {document.originalFileName}
          </Typography.Text>
          <Flex className='gap-1'>
            <Typography.Text className='text-xs font-medium leading-4 text-green-600'>
              {getDocumentTypeLabel(document.type)}
            </Typography.Text>
            <Typography.Text className='text-xs font-medium leading-4 text-gray-400'>•</Typography.Text>
            <Typography.Text className='text-xs font-medium leading-4 text-gray-400'>
              {formatDateTimeLondonNoTz(document.createdAt)}
            </Typography.Text>
          </Flex>
        </Flex>
      </Flex>
      <Button
        type='default'
        className='border border-gray-200 bg-white px-2 text-xs font-normal leading-5 text-black/90 shadow-none rounded-3xl w-11 h-6'
        onClick={handleViewClick}
      >
        View
      </Button>
    </Flex>
  );
};
